import { NagotiationModule } from './../nagotiation/nagotiation.module';
import { DashboardModule } from './../dashboard/dashboard.module';
import { CommonModule } from '@angular/common';
import { UserService } from '../Services/User.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AppModule } from '../app.module';
import { TokenService } from '../Services/Token.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: []
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule>   {
    return {
      ngModule: SharedModule,
      providers: [UserService,TokenService]
    };
  }
}
